import { render } from "./InvoiceMoney.vue?vue&type=template&id=0474e382&scoped=true"
import script from "./InvoiceMoney.vue?vue&type=script&lang=js"
export * from "./InvoiceMoney.vue?vue&type=script&lang=js"

import "./InvoiceMoney.vue?vue&type=style&index=0&id=0474e382&scoped=true&lang=less"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\partner\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0474e382"]])

export default __exports__